<p>eliminar-alianza works!</p>
